export const featuresFlags = {
  "9302": {
    uploadCertToSnap: false,
  },
  "843843": {
    uploadCertToSnap: true,
  },
  "613419": {
    uploadCertToSnap: true,
  },
};
